import { ColoredChip } from '../../../../../components/ColoredChip';
import { useUnsafeTranslation } from '../../../../../i18next';

export const ModifiedChip = ({ active }: { active?: boolean }) => {
  const { t } = useUnsafeTranslation();
  if (!active) {
    return null;
  }
  return (
    <ColoredChip color="yellow" variant="rounded" size="small" mode="light">
      {t('Modified')}
    </ColoredChip>
  );
};
